export default __webpack_public_path__ + "static/media/image-2.1ca25b82.webp";